import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api.service';
@Component({
  selector: 'app-notice-indicator',
  standalone: true,
  imports: [CommonModule, IonicModule],
  template: `<ion-item *ngIf="open" lines="none" color="light"
    ><ion-label class="ion-text-wrap"
      ><p>
        {{
          es
            ? 'Este vehículo tiene un Notice pendiente. Puedes continuar con tu registro.'
            : 'This vehicle has an open Notice. You can continue your registration.'
        }}
      </p>
      <a *ngIf="url" [href]="url" target="_blank" rel="noopener">{{
        es ? 'Consultar Notice' : 'View Notice'
      }}</a></ion-label
    ></ion-item
  >`,
})
export class NoticeIndicatorComponent implements OnChanges, OnDestroy {
  @Input() plate?: string;
  @Input() locator?: string;
  open = false;
  url?: string;
  private generation = 0;
  private timer?: ReturnType<typeof setTimeout>;
  constructor(
    private api: ApiService,
    private translate: TranslateService,
  ) {}
  get es() {
    return (
      this.translate.currentLang ??
      this.translate.defaultLang ??
      'en'
    ).startsWith('es');
  }
  ngOnChanges() {
    this.generation++;
    this.open = false;
    this.url = undefined;
    clearTimeout(this.timer);
    const generation = this.generation;
    this.timer = setTimeout(() => this.load(generation), 350);
  }
  ngOnDestroy() {
    clearTimeout(this.timer);
    this.generation++;
  }
  @HostListener('window:focus') refresh() {
    void this.load(this.generation);
  }
  private async load(generation: number) {
    const plate = this.plate?.trim();
    if (!plate || plate.length > 32) return;
    try {
      const path = 'notices/open?plate=' + encodeURIComponent(plate);
      const response = await this.api.get<{
        HasOpenNotice: boolean;
        PortalUrl?: string;
      }>(path);
      if (generation !== this.generation) return;
      this.open = response.Success && response.Data?.HasOpenNotice === true;
      if (this.open && response.Data.PortalUrl) {
        const target = new URL(response.Data.PortalUrl);
        if (target.protocol === 'https:') {
          target.searchParams.set('plate', plate);
          target.searchParams.set('returnUrl', window.location.href);
          this.url = target.href;
        }
      }
    } catch {
      if (generation === this.generation) {
        this.open = false;
        this.url = undefined;
      }
    }
  }
}
